import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Observable } from 'rxjs'

@Component({
  selector: 'ftr-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class ProgressComponent {
  /**
   * A number from 0 to 1 that indicates the bar progress
   */
  @Input() complete: Observable<number>
  /**
   * Whether there should be a marker at the end of the current progress.
   */
  @Input() displayProgressMarker = false
}
